module.exports = "/_next/static/images/69f966d985348c1e93bb27b1626bfa36-challenge-the-system-md@2x.jpg";